import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Dashboard from './pages/Dashboard'
import FileCompare from './pages/FileCompare'
import TaskManagement from './pages/TaskManagement'
import QueryManagement from './pages/QueryManagement'
import Profile from './pages/Profile'
import GoogleCallback from './pages/GoogleCallback'
import ProtectedRoute from './components/ProtectedRoute'
import React, { useEffect } from 'react'

// Marketing Website Pages
import Home from './marketing-website/pages/Home'
import AboutUs from './marketing-website/pages/AboutUs'
import Services from './marketing-website/pages/Services'
import Contact from './marketing-website/pages/Contact'
import Compliance from './marketing-website/pages/services/Compliance'

function App() {
  const { isAuthenticated, validateToken } = useAuthStore()

  useEffect(() => {
    validateToken()
  }, [validateToken])

  return (
    <Routes>
      {/* Marketing Website - Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      
      {/* Individual Service Pages */}
      <Route path="/services/compliance" element={<Compliance />} />
      {/* Add other service pages here as they are created */}
      
      {/* Public Routes */}
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/app/dashboard" replace /> : <Login />
      } />
      <Route path="/register" element={
        isAuthenticated ? <Navigate to="/app/dashboard" replace /> : <Register />
      } />
      <Route path="/forgot-password" element={
        isAuthenticated ? <Navigate to="/app/dashboard" replace /> : <ForgotPassword />
      } />
      <Route path="/reset-password" element={
        isAuthenticated ? <Navigate to="/app/dashboard" replace /> : <ResetPassword />
      } />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/google-callback" element={<GoogleCallback />} />
      
      {/* Protected Routes */}
      <Route path="/app" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="file-compare" element={<FileCompare />} />
        <Route path="tasks" element={<TaskManagement />} />
        <Route path="queries" element={<QueryManagement />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      
      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App 